function hasExpired(input) {
  if (input === undefined || input === null) {
    return false // Treat undefined/null expiration as not expired
  }

  const currentDate = new Date()
  const providedDate = new Date(input)

  return providedDate < currentDate
}

angular.module('app.api').factory('MatchesApi', [
  'api',
  function MatchesApi(api) {
    const matchesAPi = {
      getCandidateMatchesData: async (id, payload) => {
        const result = await api.get(`recommendations/candidate/${id}`, {
          params: payload,
        })
        console.debug(
          'MatchesApi::getCandidateMatchesData',
          id,
          payload,
          'result:',
          result
        )

        const withoutExpiredOrInvisible = result.data.positions.filter(item => {
          return !hasExpired(item.expiresAt) && item.visible
        })

        const toReturn = _.extend({}, result, {
          data: {
            positions: withoutExpiredOrInvisible,
            positionsCount: {
              totalPositions: result.data.positionsCount.totalPositions,
              hiddenPositions: result.data.positionsCount.hiddenPositions,
            },
          },
        })

        console.debug('MatchesApi::getCandidateMatchesData', toReturn)
        return toReturn
      },

      unHideCandidateEmployer: async (id, payload) => {
        return api.put(`users/${id}/hidden`, payload)
      },
      unHideCandidatePosition: async (id, payload) => {
        return api.put(`users/${id}/positions/hidden`, payload)
      },
    }
    return matchesAPi
  },
])



// WEBPACK FOOTER //
// ./scripts/matches/matches.api.js